import { Component, OnDestroy, OnInit, Input, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { MovieItem } from '../../../data/vod/models/movie-item';
import { BasePageComponent } from '../../commons/base-page/base-page.component';
import { PagingController } from '../../../shared/commons/paging-controller/paging-controller';
import { HelpersService } from '../../../core/helpers/helpers.service';
import { ContentP } from '../../../data/360-client-api';
import { VodDataRestService } from '../../../data/vod/vod-data-rest.service';
import { ContentExtended } from '../../../data/vod/models/contentExtended';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MetaService } from '../../../data/meta/meta.service';
import { subscriptionLogsToBeFn } from 'rxjs/testing/TestScheduler';
import { Subscription } from 'rxjs';
import { DataSharingService } from '../../../core/data-sharing/data-sharing.service';
import { ContentListResponse } from '../../../data/cms-vod-client-api/model/contentListResponses';

@Component({
  selector: 'app-content-grid',
  templateUrl: './content-grid.component.html',
  styleUrls: ['./content-grid.component.css'],
  providers: [PagingController]
})
export class ContentGridComponent extends BasePageComponent implements OnInit, OnDestroy, OnChanges {
  @Input() contentType: string;
  @Input() contentID: number;
  @Input() title: string;
  // @Output() episodeToEmit = new EventEmitter<ContentExtended>();

  public contents: ContentListResponse[] = [];
  posterCatalogs: string[] = [];
  isMobile: boolean;
  isDesktop: boolean;
  public labelID: number | null;
  labelName: string;
  routerSubs: Subscription;
  labelNameSubs: Subscription;

  constructor(helpers: HelpersService,
    private router: Router,
    // private dataSource: VodDataService,
    private vodDataService: VodDataRestService,
    private route: ActivatedRoute,
    public paging: PagingController,
    private deviceService: DeviceDetectorService,
    private dataSharing: DataSharingService

  ) {
    super(helpers);
    // route.params.subscribe(val => {
    //   this.parseParams();
    // });
    // route.queryParams.subscribe(val => {
    //   this.parseParams();
    // });
    this.isMobile = deviceService.isMobile();
    this.isDesktop = deviceService.isDesktop();
    // paging.pageChanged.subscribe(() => {
    //   this.getContent();
    // });
    this.routerSubs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('contentGrid')) {
          this.labelName = this.route.snapshot.paramMap.get('labelName');
          this.getContents();
        }
      }
    });
    this.labelName = this.route.snapshot.paramMap.get('labelName');

    // this.labelNameSubs = dataSharing.labelName$.subscribe(data => {
    //   if (data) {
    //     this.labelName = data;
    //   }
    // })

  }

  ngOnInit() {
    // this.paging.init(0, 0, 12);
    if (this.contentType == "SERIES" || this.contentType == "EPISODE") {
      this.labelName = this.title;
      this.getEpisodes(this.contentID)
    }
    else {
      this.getContents()
    }
  }

  ngOnDestroy(): void {
    // this.paging.destroy();
    if (this.routerSubs) {
      this.routerSubs.unsubscribe();
      this.routerSubs = null;
    }

    if (this.labelNameSubs) {
      this.labelNameSubs.unsubscribe();
      this.labelNameSubs = null;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.contentID && !changes.contentID.isFirstChange()) {
      this.getEpisodes(this.contentID);
    }
  }

  getContents() {
    this.labelID = +this.route.snapshot.paramMap.get('id');
    // this.labelName = this.route.snapshot.paramMap.get('labelName');
    this.vodDataService.getContentsWithLabel(this.labelID).subscribe((data: ContentExtended[]) => {
      this.contents = data;
    });
    this.paging.update(this.contents.length);
    this.contents = this.contents.slice(this.paging.current * this.paging.pageSize, (this.paging.current + 1) * this.paging.pageSize);
  }

  getEpisodes(id: number) {
    this.vodDataService.getChildVods(id).subscribe((data: ContentExtended[]) => {
      this.contents = data;
      
      // this.episodeToEmit.emit(this.contents[0])
    })
  }

  // setPoster(contents: ContentExtended[]) {
  //   contents.forEach(content => {
  //     content.posters.forEach(poster => {
  //       if (poster.posterDefinition.id == 2) {
  //         content.poster = poster.url;
  //       }
  //     });
  //   });
  // }


  public getUrl(movie: MovieItem): string {
    return [
      window.location.protocol, '//',
      window.location.hostname,
      !(window.location.port === '80' || window.location.port === '443') ? ':' + window.location.port : '',
      this.router.createUrlTree(['/contentDetail', movie.external_id]).toString()
    ].join('');
  }

  routeDetail(id, urlName: string) {
    if (this.isMobile) {
      this.router.navigate(['/contentDetail', id, urlName]);
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/vod/content-grid/content-grid.component.ts